export function trackEvent(category, action, label, property, value) {
  // Send the event to Snowplow.
  if (typeof snowplow !== 'undefined') {
    snowplow('trackStructEvent', category, action, label, property, value)
  }
}
